import Checkbox from './src/main'

Checkbox.install = function (Vue) {
    Vue.component(Checkbox.name, Checkbox)
}

export default Checkbox